import React from 'react'
import PropTypes from 'prop-types'

import { Grid, Typography } from '@material-ui/core'

import MarkdownText from 'artkive/components/MarkdownText'

import {
  Basis,
  Counts,
  CriticalQuote,
  HighlightsRoot,
  HighlightsText,
  Quote,
  QuoteAuthor,
  QuoteList,
  QuoteMeta,
  ThemeChip,
  ThemeCount,
  ThemeList,
} from './Reviews.style'

const Highlights = ({ text, basis, themes, quotes, fiveStarCount, verifiedCount, total }) => (
  <HighlightsRoot>
    <Typography variant='caption' component={Basis} align='center'>
      {basis}
    </Typography>
    <HighlightsText>
      <MarkdownText source={text} />
    </HighlightsText>
    <ThemeList>
      {themes.map(({ label, count }) => (
        <ThemeChip key={label}>
          {label} <ThemeCount>{count}</ThemeCount>
        </ThemeChip>
      ))}
    </ThemeList>
    <Grid container spacing={2} component={QuoteList}>
      {quotes.map(({ author, date, dateLabel, verified, critical, text: quote }) => {
        const QuoteBlock = critical ? CriticalQuote : Quote

        return (
          <Grid item xs={12} md={4} component='li' key={`${author}-${date}`}>
            <QuoteBlock>
              <Typography variant='body1'>“{quote}”</Typography>
              <Typography variant='caption' component={QuoteMeta}>
                <QuoteAuthor>{author}</QuoteAuthor>
                {verified && ' · Verified Customer'} · <time dateTime={date}>{dateLabel}</time>
              </Typography>
            </QuoteBlock>
          </Grid>
        )
      })}
    </Grid>
    <Typography variant='caption' component={Counts} align='center'>
      {fiveStarCount} of {total} reviews are five stars · {verifiedCount} verified purchases
    </Typography>
  </HighlightsRoot>
)

Highlights.propTypes = {
  text: PropTypes.string.isRequired,
  basis: PropTypes.string.isRequired,
  themes: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string.isRequired, count: PropTypes.number.isRequired }))
    .isRequired,
  quotes: PropTypes.arrayOf(
    PropTypes.shape({
      author: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      dateLabel: PropTypes.string.isRequired,
      verified: PropTypes.bool.isRequired,
      critical: PropTypes.bool,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  fiveStarCount: PropTypes.number.isRequired,
  verifiedCount: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
}

export default Highlights
